export default __webpack_public_path__ + "img/7e5810b34749ee59b0e41e0f16026c2e.gif";